import { useMemo,  useEffect } from "react";
import { Stack } from "@mui/material";
import { gql, useQuery, useReactiveVar } from "@apollo/client";
import { useParams, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import FormikForm, {
  FormikField,
  FormikSelect,
  FormikAutocomplete,
} from "../../../../component/formikForm";
import { onCreateOffer } from "../../pricing/onCreate";
import {
  relationsByDefiner,
  entitiyUserRelationByEntityID,
} from "../query";
import QuoteItem from "../../pricing/components/Array/QuoteItem";
import filterOutSameItemInArray from "../../../../lib/filterOutSameItemInArray";
import { userEntityRelationVar } from "../../../../client/cache";
import { toChinaDateString } from "../../../../lib/chinaDate";


const validationSchemaForCreate = Yup.object().shape({
  // alias: Yup.string().min(2, "Too Short").max(10, "Too Long"),
  // // .required("Please enter a alias"),
  // vendorCode: Yup.string().required("Please enter vendor code"),
  // statusCode: Yup.string().required("Please enter status code"),
  // contacts: Yup.array().of(
  //   Yup.object({
  //     fn: Yup.string()
  //       .min(2, "At least 2 characters")
  //       .max(10, "Too Long")
  //       .required("Please enter first name"),
  //     ln: Yup.string()
  //       .min(2, "At least 2 characters")
  //       .max(10, "Too Long")
  //       .required("Please enter last name"),
  //     email: Yup.string()
  //       .email("Invalid email")
  //       .required("Please enter a valid email"),
  //     role: Yup.array()
  //       .min(1, "Please assign at least one role")
  //       .required("Please select role(s)"),
  //   })
  // ),
});

const FormArray = [
  {
    Item: QuoteItem,
    name: "quotes",
    width: "95%",
    bgcolor: "#f3e5f5",
    btnColor: "purple",
    size: "md",
  },
];
export default function CreateForm() {
  // const { state } = useLocation() || {};
  const { entityID } = useParams();

  const initialValues = {
    number: `S${Date.now().toString().slice(1, 9)}`,
    date: toChinaDateString(),
    definerID: entityID,
    isEditing: true,
    // quotes: [{}],
  };

  const navigate = useNavigate();
  const onSubmit = async ({ values, client }) => {
    await onCreateOffer({
      values,
      client,
      statusCode: "050",
    });

    navigate(-1);
  };
  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <FormikForm
      initialValues={initialValues}
      validationSchema={validationSchemaForCreate}
      onSubmit={onSubmit}
      FormMainFields={CreateFields}
      FormArray={FormArray}
      handleCancel={handleCancel}
    />
  );
}

const CreateFields = ({ values, setFieldValue, setValues }) => {
  const { definerID } = values;

  const {entityID,subsidiaryIDs} = useReactiveVar(userEntityRelationVar);

  let { data: relationsByDefinerData } = useQuery(gql(relationsByDefiner), {
    variables: {
      definerID,
      relation: { eq: "CUSTOMER-SUPPLIER" },
      filter: {
        or: [entityID, ...subsidiaryIDs].map((x) => ({ entity1ID: { eq: x } })),
      },
    },
  });

  relationsByDefinerData = relationsByDefinerData?.relationsByDefiner?.items;

  const { data: entitiyUserRelationByEntityIDData } = useQuery(
    gql(entitiyUserRelationByEntityID),
    {
      variables: {
        entityID: values?.vendor?.id,
        definerID: { eq: definerID },
        filter: { role: { eq: "sales" } },
      },
      skip: !values?.vendor?.id,
    }
  );

  const salesOptions = useMemo(
    () =>
      entitiyUserRelationByEntityIDData?.entitiyUserRelationByEntityID?.items?.map(
        (x) => ({
          ...x.user,
        })
      ),
    [entitiyUserRelationByEntityIDData?.entitiyUserRelationByEntityID?.items]
  );

  const { data: entitiyUserRelationByEntityIDData2 } = useQuery(
    gql(entitiyUserRelationByEntityID),
    {
      variables: {
        entityID: values?.customer?.id,
        definerID: { eq: definerID },
        filter: { role: { eq: "buyer" } },
      },
      skip: !values?.customer?.id,
    }
  );

  const buyerOptions = useMemo(
    () =>
      entitiyUserRelationByEntityIDData2?.entitiyUserRelationByEntityID?.items?.map(
        (x) => ({
          ...x.user,
        })
      ),
    [entitiyUserRelationByEntityIDData2?.entitiyUserRelationByEntityID?.items]
  );

  let vendorOptions = relationsByDefinerData?.map((x) => ({
    ...x.entity2,
  }));

  vendorOptions = useMemo(
    () => filterOutSameItemInArray(vendorOptions, "id"),
    [vendorOptions]
  );

  const customerOptions = useMemo(
    () =>
      relationsByDefinerData
        ?.filter((x) => x.entity2ID === values?.vendor?.id)
        ?.map((x) => ({
          ...x.entity1,
          incoTerms: x.incoTerms,
          paymentTerms: x.paymentTerms,
        })),
    [relationsByDefinerData, values?.vendor?.id]
  );

  const incoTermsOptions = values?.customer?.incoTerms;

  const paymentTermsOptions = values?.customer?.paymentTerms;

  console.log({ incoTermsOptions, paymentTermsOptions });

  useEffect(() => {
    if (buyerOptions?.length === 1) {
      setFieldValue("buyer", buyerOptions[0]);
    }
  }, [buyerOptions, setFieldValue]);

  useEffect(() => {
    if (salesOptions?.length === 1) {
      setFieldValue("sales", salesOptions[0]);
    }
  }, [salesOptions, setFieldValue]);

  useEffect(() => {
    if (incoTermsOptions?.length === 1) {
      setFieldValue("incoTerms", incoTermsOptions[0]);
    }
  }, [incoTermsOptions, setFieldValue]);

  useEffect(() => {
    if (paymentTermsOptions?.length === 1) {
      setFieldValue("paymentTerms", paymentTermsOptions[0]);
    }
  }, [paymentTermsOptions, setFieldValue]);

  useEffect(() => {
    if (customerOptions?.length === 1) {
      setFieldValue("customer", customerOptions[0]);
    } else {
      setFieldValue("customer", null);
    }
  }, [setFieldValue, customerOptions]);

  return (
    <Stack width={1600} spacing={2}>
      <Stack direction="row" spacing={5} alignItems="flex-end">
        <FormikField
          name="number"
          label="Number"
          disabled
          required
          width={180}
        />
        <FormikField
          name="date"
          label="Date"
          type="date"
          required
          width={180}
        />
      </Stack>

      <Stack direction="row" spacing={5} alignItems="flex-end">
        <FormikAutocomplete
          name="vendor"
          label="Vendor"
          options={vendorOptions}
          getOptionLabel={(option) => option.alias || option.name}
          required
          getPrimaryText={(option) => option.alias || option.name}
          getSecondaryText={null}
          listItemPrimaryField={null}
          listItemSecondaryField={null}
          disabled={false}
          width={240}
          onChange={() => {
            setFieldValue("quotes", []);
            setFieldValue("buyer", null);
            setFieldValue("sales", null);
            setFieldValue("customer", null);
            setFieldValue("incoTerms", null);
            setFieldValue("paymentTerms", null);
          }}
          getOptionDisabled={null}
        />
        <FormikAutocomplete
          name="sales"
          label="Sales"
          options={salesOptions}
          getOptionLabel={(option) => option.name}
          required
          getPrimaryText={(option) => option.name}
          getSecondaryText={null}
          listItemPrimaryField={null}
          listItemSecondaryField={null}
          disabled={false}
          width={240}
          onChange={null}
          getOptionDisabled={null}
        />

        <FormikAutocomplete
          name="customer"
          label="Customer"
          options={customerOptions}
          getOptionLabel={(option) => option.alias || option.name}
          required
          getPrimaryText={(option) => option.alias || option.name}
          width={240}
          // getOptionDisabled={getOptionDisabled}
        />
        <FormikAutocomplete
          name="buyer"
          label="Buyer"
          options={buyerOptions}
          getOptionLabel={(option) => option.name}
          required
          getPrimaryText={(option) => option.name}
          getSecondaryText={null}
          listItemPrimaryField={null}
          listItemSecondaryField={null}
          disabled={false}
          width={240}
          onChange={null}
          getOptionDisabled={null}
        />
      </Stack>

      <Stack direction="row" spacing={2} alignItems="flex-end">
        <FormikAutocomplete
          name="incoTerms"
          label="incoTerms"
          options={incoTermsOptions}
          getOptionLabel={(option) => option.terms}
          required
          getPrimaryText={(option) => option.terms}
          getSecondaryText={null}
          listItemPrimaryField={null}
          listItemSecondaryField={null}
          disabled={false}
          width={240}
          onChange={null}
          getOptionDisabled={null}
        />

        <FormikSelect
          label="PaymentTerms"
          name="paymentTerms"
          width={300}
          options={paymentTermsOptions}
          required
          // labelKey="label"
          // valueKey="value"
        />
      </Stack>
    </Stack>
  );
};
